import React from 'react';
import { EditorState, Modifier, SelectionState } from 'draft-js';
import { MetaInfo } from 'lib/components/MetaInfo';

export class MetaBlock extends React.Component {
	render() {
		const { entityData, store } = this.props.blockProps;
		const { icon, title, metas } = entityData;

		return (
			<div className="meta-block">
				<MetaInfo icon={icon} title={title} metas={metas}></MetaInfo>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/metaPlugin/MetaBlock.jsx